import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { PavilionLogo } from './PavilionLogo';
export function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Menu',
    href: '#menu'
  }, {
    name: 'Workshops',
    href: '#workshops'
  }, {
    name: 'Vendors',
    href: '#vendors'
  }, {
    name: 'Partners',
    href: '#partners'
  }];
  return <nav className="sticky top-0 z-50 bg-foodCream border-b-4 border-foodMaroon" data-id="element-171" data-mp="1fynt4u5f7rn8">
      <div className="bg-foodTeal text-foodCream text-center text-xs sm:text-sm font-bold uppercase tracking-wide py-2 px-4" data-id="element-172" data-mp="1ky8u1a45ia2l">
        <span className="whitespace-nowrap" data-id="element-173" data-mp="1pqth7ssjxox5">
          <span className="text-foodGold" data-id="element-174" data-mp="1uolk1huqivg4">Mon</span> 9 AM – 2 PM
        </span>{' '}
        •{' '}
        <span className="whitespace-nowrap" data-id="element-175" data-mp="1yq6u6vfvwvmm">
          <span className="text-foodGold" data-id="element-176" data-mp="1yr88r9w40093">Wed</span> 2 PM – 7 PM
        </span>
        <span className="hidden sm:inline" data-id="element-177" data-mp="23oqdsp709vbt"> • </span>
        <span className="block sm:inline whitespace-nowrap" data-id="element-178" data-mp="23n70n7gnc0e9">
          <span className="text-foodGold" data-id="element-179" data-mp="1y6zwtmb1fzba">Sat & Sun</span> 12 PM – 6 PM
        </span>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180" data-mp="1u3abr6tknzv0">
        <div className="flex justify-between items-center h-20" data-id="element-181" data-mp="1p58w6vvcuioa">
          <a href="#" aria-label="The Food Pavilion, home" className="shrink-0" data-id="element-182" data-mp="1p5ik8dwuafrc">
            <PavilionLogo data-id="element-183" data-mp="1k7h0rrvi4efc" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-7 ml-12" data-id="element-184" data-mp="2hu7dxrvkfit2">
            {links.map(link => <a key={link.name} href={link.href} className="font-bold hover:text-foodOrange transition-colors duration-150" data-id="element-185" data-mp="2cvw4hi96nabd">
                {link.name}
              </a>)}
            <a href="https://www.en2action.org/" target="_blank" rel="noopener noreferrer" className="font-bold hover:text-foodOrange transition-colors duration-150" data-id="element-186" data-mp="23376nq6k1uyi">
              En2Action
            </a>
            <a href="#popups" className="bg-foodOrange text-white px-6 py-2.5 font-bold border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#2A1B14] hover:shadow-[2px_2px_0px_0px_#2A1B14] hover:translate-y-[2px] hover:translate-x-[2px] transition-[transform,box-shadow] duration-150 ease-out" data-id="element-187" data-mp="twoorswvv3os">
              Pop Ups
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center gap-3" data-id="element-188" data-mp="aain040emsuj">
            <a href="https://ibwaterfrontpark.com/" target="_blank" rel="noopener noreferrer" aria-label="India Basin Waterfront Park" data-id="element-189" data-mp="f824rdwb9nr8">
              <img src="https://cdn.magicpatterns.com/uploads/nYkbhZjohnn3Xbm3r4WWAs/Untitled_design_(5).png" alt="India Basin Waterfront Park" className="h-12 w-auto object-contain" data-id="element-190" data-mp="6745ta0qc6fi" />
            </a>
            <button onClick={() => setIsOpen(!isOpen)} className="hover:text-foodOrange focus:outline-none" aria-label="Toggle menu" aria-expanded={isOpen} data-id="element-191" data-mp="2ao0m2nkbq7g9">
              {isOpen ? <X size={32} data-id="element-192" data-mp="2jif1cq4uthzd" /> : <Menu size={32} data-id="element-193" data-mp="2jiymsgtpqoi5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="lg:hidden bg-foodCream border-t-4 border-foodMaroon absolute w-full" data-id="element-194" data-mp="2teidmotf6x01">
          <div className="px-4 pt-2 pb-6 space-y-2 shadow-xl" data-id="element-195" data-mp="2oggkfb2a5hau">
            {links.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="block px-3 py-3 text-2xl font-display font-bold uppercase hover:bg-foodGold transition-colors" data-id="element-196" data-mp="32g86lz2ya3zx">
                {link.name}
              </a>)}
            <a href="https://www.en2action.org/" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="block px-3 py-3 text-2xl font-display font-bold uppercase hover:bg-foodGold transition-colors" data-id="element-197" data-mp="141exchmsl61z">
              En2Action
            </a>
            <a href="#popups" onClick={() => setIsOpen(false)} className="block mt-4 text-center bg-foodOrange text-white px-6 py-3 font-bold text-xl border-2 border-foodMaroon shadow-[4px_4px_0px_0px_#2A1B14]" data-id="element-198" data-mp="1jh1sb867nas0">
              Pop Ups
            </a>
          </div>
        </div>}
    </nav>;
}